<template>
  <div class="wrapper" :style="'--main-color:' + mainColor + ';--main-rgba:' + mainColorRgba">
    <router-view :key="$route.path"></router-view>
    <!-- :key="$route.fullPath" -->
  </div>
</template>

<script>
import { getWxShareInfo } from './api/user'
import { removeRequestAppType } from './utils/cookies'
export default {
  name: 'app',
  data() {
    return {
      mainColor: '#13bf80',
      mainColorRgba: '137,223,191',
    }
  },

  created() {
    removeRequestAppType()

    let currentBrand = this.getCurrentBrand,
      currentBrandColor = this.getCurrentBrandColor()

    this.setFavicon(currentBrand.imageLogoURL)
    this.mainColor = currentBrandColor.mainColor
    this.mainColorRgba = currentBrandColor.mainColorRgba
    // 测试服和本地显示打印
    // if (window.location.origin.indexOf('test') !== -1 || window.location.href.indexOf('localhost:') !== -1) {
    //   new VConsole()
    // }

    // 初始化微信分享
    getWxShareInfo({ url: window.location.href, brand: currentBrand.brandKey }).then((res) => {
      let packages = res.data.package
      window.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: packages.appId, // 必填，公众号的唯一标识
        timestamp: packages.timestamp, // 必填，生成签名的时间戳
        nonceStr: packages.nonceStr, // 必填，生成签名的随机串
        signature: packages.signature, // 必填，签名
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareAppMessage',
        ], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-app'],
      })
      window.wx.ready((res) => {
        console.log(res)
      })

      window.wx.error((error) => {
        console.log(error)
      })
      // 默认调用一次分享
      this.$util.setShare()
    })
  },
  methods: {
    setFavicon(url) {
      let link = document.querySelector('link[rel*="icon"]') || document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = url
      document.getElementsByTagName('head')[0].appendChild(link)
    },
  },
}
</script>

<style lang="scss">
@font-face {
  font-family: DIN-Bold;
  src: url(./assets/fonts/DIN-Bold.otf);
}

@font-face {
  font-family: DIN;
  src: url(./assets/fonts/DIN-Medium.otf);
}

.wrapper {
  min-height: 100vh;
}

.wrapper,
.buy-button {
  @include margin_center;
  max-width: $maxWidth;
}

.text-color-main {
  color: var(--main-color) !important;
}

.van-button--primary {
  background-color: var(--main-color) !important;
  border-color: var(--main-color) !important;
}

.jbc-tabs {
  .van-tabs__line {
    background: var(--main-color);
  }
}

.vjs-poster {
  background-size: cover;
}

img {
  max-width: 100%;
}
</style>
